"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeSegment = void 0;
var TimeSegment;
exports.TimeSegment = TimeSegment;

(function (TimeSegment) {
  TimeSegment["Hours"] = "hours";
  TimeSegment["Minutes"] = "minutes";
  TimeSegment["Seconds"] = "seconds";
  TimeSegment["Milliseconds"] = "milliseconds";
})(TimeSegment || (exports.TimeSegment = TimeSegment = {}));